export enum FilterType {
    TEXT = "text",
    NUMBER = "numeric",
    BOOLEAN = "boolean",
    DATE = "date",
    OBJECT = "object",
}

